<script setup lang="ts">
import BigActionButton from '@/components/BigActionButton.vue';
import { childActions } from '@/data/navigation';
import { useFamily } from '@/composables/useFamily';
import { useNavigation } from '@/composables/useNavigation';

const { playRequestChildStatusText, selectedFriend, setMailboxViewer, unreadChildMessageCount, visibleChildPlayRequests } = useFamily();
const { navigate } = useNavigation();

function openAction(key: string) {
  if (key === 'drawing') navigate('drawing');
  if (key === 'audio') navigate('voice');
  if (key === 'video') navigate('video');
  if (key === 'play') navigate('play-request');
  if (key === 'mailbox') {
    setMailboxViewer('child');
    navigate('mailbox');
  }
  if (key === 'parent') navigate('parent-settings');
}
</script>

<template>
  <section class="mx-auto max-w-7xl px-4 py-6 pb-28 sm:px-6 md:pb-10">
    <button class="focus-ring rounded-full bg-white px-5 py-3 font-black text-heart-ink shadow-sm" type="button" @click="navigate('child-home')">
      Zurueck
    </button>
    <div class="mt-5">
      <h1 class="text-4xl font-black text-heart-berry md:text-6xl">{{ selectedFriend.displayName }}s Haus</h1>
      <p class="mt-3 text-xl font-bold text-heart-ink">Waehle mit einem Fingertipp aus.</p>
    </div>

    <div class="mt-6 grid gap-3">
      <div
        v-for="request in visibleChildPlayRequests.filter((entry) => entry.receiverChildId === selectedFriend.friendChildId || entry.senderChildId === selectedFriend.friendChildId)"
        :key="request.id"
        class="rounded-[24px] bg-white px-5 py-4 text-xl font-black text-heart-ink shadow-soft"
      >
        {{ playRequestChildStatusText(request.status, selectedFriend.displayName) }}
      </div>
    </div>

    <div class="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      <BigActionButton
        v-for="action in childActions"
        :key="action.key"
        :label="action.label"
        :icon="action.icon"
        :tone="action.tone"
        :badge-count="action.key === 'mailbox' ? unreadChildMessageCount : 0"
        @click="openAction(action.key)"
      />
    </div>
  </section>
</template>
